var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 41,
    viewBox: "0 0 49 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 49"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_572_20141",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.113555 35.7548C3.45865 25.6063 9.84896 16.7348 18.4151 10.3472C26.9812 3.95953 37.3072 0.365932 47.9882 0.0552988L48.4247 15.063C40.8276 15.2839 33.4831 17.8399 27.3902 22.3833C21.2974 26.9266 16.7522 33.2366 14.3729 40.4549L0.113555 35.7548Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.113555 35.7548C3.45865 25.6063 9.84896 16.7348 18.4151 10.3472C26.9812 3.95953 37.3072 0.365932 47.9882 0.0552988L48.4247 15.063C40.8276 15.2839 33.4831 17.8399 27.3902 22.3833C21.2974 26.9266 16.7522 33.2366 14.3729 40.4549L0.113555 35.7548Z",
    fill: "white",
    fillOpacity: 0.1,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 16,
    mask: "url(#path-1-inside-1_572_20141)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/Ellipse.8e57d55bdae5affe930977ab4c3e3837.svg";
export { ForwardRef as ReactComponent };